import { VStack } from "@chakra-ui/react";
import { useRef } from "react";
import { FaUserAltSlash } from "react-icons/fa";
import { DynamicListType } from "../../../../../common/types/campaign";
import DynamicList from "../../../../../components/dynamic-list/DynamicList";
import IconWithText from "../../components/IconWithText";
import CommonDrawer from "../../components/CommonDrawer";
import { useSelector } from "react-redux";
import { selectCampaign } from "../../campaignSlice";
import SectionTitle from "./components/SectionTitle";
import CampaignDynamicList from "../../CampaignDynamicList";

export default function AudienceFilterSection({
  isOpen,
  onOpen,
  onClose,
  readonly,
  errorText,
  data,
  onChange,
  saveDraft,
}: {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  readonly: boolean;
  errorText: string;
  data: DynamicListType[];
  onChange: (dynamicList: DynamicListType[]) => void;
  saveDraft: (dynamicList: DynamicListType[]) => void;
}) {
  const btnRef = useRef();

  const {
    campaignDetails: {
      data: { active, campaign_context: campaignContext },
    },
    activeErrorCheck,
  } = useSelector(selectCampaign);

  return (
    <VStack alignItems="flex-start">
      <SectionTitle
        title="Audience"
        readonly={readonly}
        btnRef={btnRef}
        onOpen={onOpen}
        active={active}
        activeErrorCheck={activeErrorCheck}
        errorText={errorText}
      />

      {data.length ? (
        <DynamicList
          dynamicListData={data ?? []}
          onChange={() => {}}
          sidebar={false}
          activeErrorCheck={false}
          campaignContext={campaignContext}
          readOnlyMode
        />
      ) : (
        <IconWithText text="No audience selected" icon={FaUserAltSlash} />
      )}

      <CommonDrawer
        title="Audience"
        btnRef={btnRef}
        isOpen={isOpen}
        onClose={onClose}
        size="3xl"
      >
        <CampaignDynamicList
          dynamicList={data ?? []}
          setDynamicList={(data) => onChange(data)}
          saveDraft={saveDraft}
          isReadOnly={readonly}
          campaignContext={campaignContext}
        />
      </CommonDrawer>
    </VStack>
  );
}
